export enum AddressType {
	PARTICULAR,
	JOB_ADDRESS,
	BRANCH_ADDRESS,
	OTHER,
}

export interface AddressDetails {
	street: string;
	exteriorNumber: string;
	interiorNumber: string;
	postalCode: number;
	colonyId?: number;
	colony: string;
	addressType: AddressType;
}
